// extracted by mini-css-extract-plugin
module.exports = {"container":"authorArticles_container__YDdR6","articles":"authorArticles_articles__mcf5m"};